<div class="overflow-hidden details-panel" [@verticalCollapse]="collapsestate">
  <div
    class="bg-light note-input d-flex justify-content-center align-items-start flex-column"
    [ngClass]="{
      'w-auto': !showAddNote,
      'p-0': !showAddNote && !discount?.min && !discount?.max
    }"
  >
    <div
      class="pre-pack-row-item d-flex align-items-center"
      *ngIf="discountVisible && (discount?.min || discount?.max)"
    >
      <atx-discount-label
        *atxCanShowByWsp
        class="mr-2 align-items-center d-flex justify-content-center text-success"
        [discount]="discount"
      ></atx-discount-label>
    </div>
    <div class="mt-2 w-100 position-relative" *ngIf="showAddNote">
      <fa-icon [icon]="['fas', 'file-plus']" class="note-icon"></fa-icon>
      <textarea
        class="form-control"
        type="text"
        maxlength="20"
        [formControl]="noteControl"
        placeholder="Type a note"
        data-e2e="note-input"
        i18n-placeholder="
          pre-pack component|note field placeholder@@notePlaceholder"
      ></textarea>
    </div>
  </div>
  <epc-size-grid
    *ngIf="deliveryItems && showSizeGrid"
    class="nested"
    [class.no-bl]="!showAddNote"
    [deliveryItems]="deliveryItems"
    [materials]="prepack?.variants || []"
    [availableScaleSets]="scaleSets"
    [selectedScale]="selectedScale"
    [titleAttributes]="titleAttributes"
    [portable]="portableGrid"
    [showTotals]="false"
    [readonly]="true"
    [disableOutsideClick]="true"
    [differentMaterialDimensions]="differentMaterialDimensions"
    [productImageMissingVisualConfig]="productImageMissingVisualConfig"
    (clickedMaterialImage)="clickMaterialImage($event)"
    data-e2e="size-grid"
  ></epc-size-grid>
</div>
